import {GlobalEventsMap, IEventManagerWithAsync, Module} from '@gongxigames/framework/slot';
import {PremonitionView} from 'src/premonition/PremonitionView';
import {GameReelsSpinningState} from 'src/gameReels/states/GameReelsSpinningState';

export class PremonitionModule extends Module<PremonitionView> {
    public static readonly NAME: symbol = Symbol('PremonitionModule');
    public static PREMONITION_FINISHED = 'PREMONITION_FINISHED';

    protected setupStates(): void {
    }

    protected setupViews(): void {
        this.setView(PremonitionView.NAME);
    }

    protected setupEvents(): void {
        super.setupEvents();
        this.onView(PremonitionView.PREMONITION_FINISHED, this.onPremonitionFinished.bind(this));
        this.on(GameReelsSpinningState.SHOULD_PLAY_PREMONITION, this.onShouldPlayPremonition.bind(this));
    }

    protected onShouldPlayPremonition(): void {
        this.view.play();
        (this.eventManager as IEventManagerWithAsync<GlobalEventsMap>).emit('General.UI.DISABLE', PremonitionModule.NAME);
    }

    protected onPremonitionFinished(): void {
        this.eventManager.emit(PremonitionModule.PREMONITION_FINISHED);
        (this.eventManager as IEventManagerWithAsync<GlobalEventsMap>).emit('General.UI.ENABLE', PremonitionModule.NAME);
    }
}
